import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes} from '@angular/router';

import {PrimeNGModule} from '../../core';
import {AuthGuardService} from '../../core/auth';

import {UserService} from '../../core/services';
import {UserCreationPage, UserDetailsPage, UserListPage} from './pages';
import {
  UserActivationComponent,
  UserApiKeyComponent,
  UserDetailsEditComponent,
  UserDetailsGroupsComponent,
  UserPasswordValidationComponent
} from './components';
import {SharedModule} from '../../shared/share.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserPasswordUpdateComponent} from './components/user-password-update/user-password-update.component';


const routes: Routes = [
  {
    path: 'users',
    component: UserListPage,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    data: {title: 'User Overview', roles: ['AC_MANAGE_USER', 'AC_READ_USER']}
  },
];


@NgModule({
  imports: [CommonModule, PrimeNGModule, SharedModule, FormsModule, ReactiveFormsModule],
  declarations: [UserListPage, UserCreationPage, UserDetailsPage, UserDetailsEditComponent, UserDetailsGroupsComponent, UserApiKeyComponent, UserPasswordUpdateComponent, UserPasswordValidationComponent, UserActivationComponent],
  exports: [
    UserActivationComponent,
    UserPasswordUpdateComponent,
    UserApiKeyComponent
  ],
  providers: [UserService]
})
export class UserModule {
}
